module.exports = __webpack_public_path__ + "img/man-red.5c94c7e.svg";